import { Observable } from 'rxjs';
import { GeneralResponse } from '../interfaces/general-response';


export abstract class AuthService {

    abstract auth(rut: number, ci: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo: number): Observable<GeneralResponse<any>>;
    abstract authLogin(rut: number, correo: string, telefono: number, producto: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo:number,isMarketplaceSVA:boolean): Observable<GeneralResponse<any>>;
}
